
import { createReducer, on } from '@ngrx/store';
import { loadBrokerFormConfigData, loadBrokerFormConfigDataSuccess, loadBrokerFormConfigDataFailure } from '../actions/brokerFormConfig.actions';

export interface State {
  brokerFormConfigData: any[];
  loading: boolean;
  error: string | null;
}

export const initialState: State = {
  brokerFormConfigData: [],
  loading: false,
  error: null,
};

export const brokerFormConfigReducer = createReducer(
  initialState,
  on(loadBrokerFormConfigData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadBrokerFormConfigDataSuccess, (state, { brokerFormConfigData }) => {
    // console.log({brokerFormConfigData})
    return ({
    ...state,
    loading: false,
    brokerFormConfigData: brokerFormConfigData,
  })}),
  on(loadBrokerFormConfigDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
